<template>
    <product-card-layout-mobile
        :product-link="productLink"
        :name="product.name"
        :thumb="product.mainImage"
        :offers-count="product.offers && product.offers.length"
        :is-recommended="product.recommended"
        :is-package="isPackage"
        :_expanded-count="expanded"
        :_expanded-limit="expandedLimit"
        @change-expanded-count="expanded = $event"
        @change-expanded-limit="expandedLimit = $event"
    >
        <template v-slot>
            <div
                v-if="product.shortDescription"
                class="short-description mt-3"
                v-html="$filters.stripHtml(product.shortDescription)"
            />
        </template>
        <template v-slot:price>
            <slot name="price" :offer="minPriceOffer">
                <template v-if="!minPriceOffer.soldOut">
                    <div class="font-weight-medium text-h6">
                        <span>{{ $t('from') }} {{ $filters.price(minPriceOffer.price) }}</span>
                    </div>
                    <discount-label :price="minPriceOffer.price" />
                    <commission-amount :commission="minPriceOffer.price.commission" />
                </template>
            </slot>
        </template>
        <template v-slot:offers>
            <visa-offer-card
                v-for="(offer, offerIndex) in sortedFilteredOffers"
                :key="offerIndex"
                :offer="offer"
                :full-card="false"
            >
                <template v-slot:price="{offer}">
                    <slot name="price" :offer="offer" />
                </template>
            </visa-offer-card>
            <v-list-item
                v-if="expanded === expandedLimit && product.offers.length > expandedLimit"
                density="compact"
                class="d-flex justify-center"
                @click.stop="expand"
            >
                <v-icon>mdi-chevron-down</v-icon>
            </v-list-item>
        </template>
    </product-card-layout-mobile>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import DiscountLabel from '~src/components/snippets/discountLabel.src'
    import CommissionAmount from '~/components/snippets/CommissionAmount.vue'
    import {VisaCard} from '~/components/visa/search/offers/VisaCard.vue'
    import VisaOfferCard from '@/components/visa/info/VisaOfferCard.vue'
    import ProductCardLayoutMobile from '~/components/search/ProductCardLayoutMobile.vue'

    @Component({
        components: {
            DiscountLabel,
            CommissionAmount,
            VisaOfferCard,
            ProductCardLayoutMobile,
        },
    })
    export class VisaCardMobile extends VisaCard {}

    export default VisaCardMobile
</script>
